import React from "react";
import "./footer.css";

function Footer() {
  return (
    <>
      <footer className="footer-flex">
        <footer>
          <div className="wave-footer"></div>
          <div className="footer-style">
            <p>© 2023 eXchangeMate</p>
          </div>
        </footer>
      </footer>
    </>
  );
}

export default Footer;
